import { AsyncPipe, NgClass } from '@angular/common';
import { Component, EventEmitter, Output, inject } from '@angular/core';
import { LoaderService } from '../../../../services/loader.service';
import { ScreenSizeService, ViewMode } from '../../../../services/screen-size';
import { PaginationService } from '../../../../services/suchseite/pagination.service';
import { LIB_CONFIG, LibConfig } from '../../../../lib.config';
import { AccumulatedBildungsangeboteService } from '../../../../services/accumulatedBildungsangebote.service';
import { CommonStateService } from '../../../../services/state/common-state.service';
import { AngebotListItemComponent } from '../../../angebot-list-item/angebot-list-item.component';
import { SuchergebnisHitsCardComponent } from '../../suchergebnis-hits-card/suchergebnis-hits-card.component';
import { UrlService } from '../../../../services/state/url.service';

@Component({
  selector: 'now-wbsuche-lib-vollbreit-ansicht',
  templateUrl: './vollbreit-ansicht.component.html',
  styleUrls: ['./vollbreit-ansicht.component.scss'],
  imports: [SuchergebnisHitsCardComponent, NgClass, AngebotListItemComponent, AsyncPipe]
})
export class VollbreitAnsichtComponent {
  private readonly screenSizeService = inject(ScreenSizeService);
  paginationService = inject(PaginationService);
  accumulatedBildungsangeboteService = inject(AccumulatedBildungsangeboteService);
  loaderService = inject(LoaderService);
  private readonly urlService = inject(UrlService);
  private readonly commonStateService = inject(CommonStateService);
  libConfig = inject<LibConfig>(LIB_CONFIG);

  @Output() terminSelected = new EventEmitter<string>();

  public bildungsangebote$ = this.accumulatedBildungsangeboteService.bildungsangebote$;
  public isDesktop$ = this.screenSizeService.rangeFrom$(ViewMode.DESKTOP);
  public angeboteLoadingByPageChange$ = this.loaderService.angeboteLoadingByPageChange$;
  public expandedAngebotIds$ = this.commonStateService.expandedAngebotIds$;
  public selectedAngebotId$ = this.commonStateService.selectedAngebotId$;
  public angeboteLoadingWithoutPageChange$ = this.loaderService.angeboteLoadingWithoutPageChange$;

  public prevPageClicked() {
    this.paginationService.previousPage();
    this.loaderService.setAngeboteTriggeredByPageChange();
  }

  public nextPageClicked() {
    this.paginationService.nextPage();
    this.loaderService.setAngeboteTriggeredByPageChange();
  }

  public toggleExpandedAngebot(angebotId: number): void {
    this.commonStateService.toggleExpandedAngebotId(angebotId);
  }

  async navigateToThemenfelder() {
    await this.urlService.updateUrl(null, 'themenfelder');
  }
}
